import {
	MimaButton,
	Modal,
	MimaDropdown,
	MimaInput,
	PageLoader,
	MimaText,
} from '../../components';
import styles from '../../assets/styles/PayBills/PayBills.module.scss';
import { EnterPinContainer } from '../../containers';
import { billStore } from '../../stores';
import { Formik } from 'formik';
import React, { useMemo, useState } from 'react';
import { useGetCableTvPlans, useGetCableTvVendors } from '../../controllers/BillController';
function DSTV({
	closeModal,
	clear,
	loading,
	pinContent,
	cablePackages,
	accountName,
	validateCardNumber,
	validationSchema,
	onSubmit,
	goBack,
	setShowSurvey,
	needFeedback,
}) {
	const [cableTVCode, setCableTVCode] = useState("");
	const [smartCardNo, setSmartCardNo] = useState("");

	const { tvVendors } = useGetCableTvVendors();
	const { cableTvPlans } = useGetCableTvPlans(cableTVCode, smartCardNo);

	const tvVendorsList = useMemo(() => {
		const mappedTvVendors = tvVendors.map((x) => {
			return (
				{
					id: x.id,
					value: x.product_name,
					payBoroCode: x.payBoroCode,
					productCode: x.product_code,
				}
			)
		})
		return mappedTvVendors;
	}, [tvVendors])

	const mappedCableTvPlan = cableTvPlans.map((x) => (
		{
			id: x._id,
			value: x.name,
		}
	))

	return (
		<Modal closeModal={closeModal} goBack={goBack}>

			<MimaText variant="subtitle" mb={4}>Cable TV</MimaText>
			{!pinContent && (
				<Formik
					initialValues={{
						smartCardNo: '',
						package: '',
						packageName: '',
						customerName: accountName,
						cableTVCode: '',
						cableTvName: '',
						productCode: '',
					}}
					validationSchema={validationSchema}
					onSubmit={onSubmit}
				>
					{({
						handleChange,
						handleBlur,
						handleSubmit,
						setFieldValue,
						values,
						errors,
						touched,
					}) => (
						<>
							<MimaDropdown
								labelTitle="Select Cable TV"
								placeholder="-Select-"
								id="cableTVCode"
								name="cableTVCode"
								mb={2}
								value={values.cableTvName}
								data={tvVendorsList}
								onChange={data => {
									clear();
									setFieldValue('cableTVCode', data.payBoroCode);
									setFieldValue('cableTvName', data.value);
									setCableTVCode(data.payBoroCode);
									setFieldValue('productCode', data.productCode);
									validateCardNumber(data.productCode, values.smartCardNo);
								}}
								error={errors.cableTvName}
								touched={touched.cableTvName}
							/>
							<MimaInput
								type="text"
								placeholder="Enter Smart Card No"
								labelTitle="Smart Card No"
								name="smartCardNo"
								mb={2}
								value={values.smartCardNo}
								onChange={e => {
									if (e.target.value && e.target.value.length === 10)
										validateCardNumber(values.productCode, e.target.value);
										setSmartCardNo(e.target.value)
									handleChange(e);
								}}
								onBlur={handleBlur}
								error={errors.smartCardNo}
								touched={touched.smartCardNo}
							/>
							{loading ? (
								<PageLoader title="In progess ..." loading={loading} />
							) : (
								<>
									<MimaInput
										type="text"
										placeholder={accountName}
										labelTitle="Account Name"
										disabled={true}
										name="accountName"
										mb={2}
										value={accountName}
									/>
								</>
							)}
							<MimaDropdown
								labelTitle="Select Package"
								placeholder="-Select-"
								id="package"
								name="package"
								value={values.packageName}
								data={mappedCableTvPlan}
								onChange={data => {
									setFieldValue('package', data.id);
									setFieldValue('packageName', data.value);
								}}
								error={errors.package}
								touched={touched.package}
							/>

							<MimaButton
								title="Continue"
								onClick={handleSubmit}
								type="submit"
								mt={2}
							/>
						</>
					)}
				</Formik>
			)}

			{pinContent && <EnterPinContainer closeModal={closeModal} setShowSurvey={setShowSurvey} needFeedback={needFeedback} />}
		</Modal>
	);
}

export default DSTV;
